import {Pipe, PipeTransform} from '@angular/core';
import {FundProductTypesEnum, ProductSubType} from '@spa/api';
import {Helper} from '../classes';
import {LanguageService} from "../language.service";
import {Product} from "../../pages/portal/services";

@Pipe({
	name: 'productTypeOrSubType'
})
export class ProductTypeOrSubTypePipe implements PipeTransform {

	constructor(private languageService: LanguageService) {
	}

	transform(product: Product): string {
		return Helper.textsHelper().getProductTypeOrSubTypeName(product.type, product.subType, this.languageService.getCurrentLanguage());
	}
}
